export enum ReceivableRouteName {
    Index = 'finance.receivables.index',
    Notify = 'finance.receivables.notify',
}

export default {
    path: 'receivables',
    name: ReceivableRouteName.Index,
    component: () => import('@/views/finance/receivables/Index.vue'),
    meta: {
        label: 'Receivables',
        auth: true,
        permission: 'manage-receivables',
        icon: 'fal fa-user-clock fa-fw',
        location: 'sidebar',
        parent: 'finance',
    },
    children: [
        {
            path: ':customerId?/notify',
            name: ReceivableRouteName.Notify,
            component: () => import('@/views/finance/receivables/Index.vue'),
            meta: {
                label: 'Notify',
                auth: true,
                permission: 'manage-receivables',
                icon: 'fal fa-user-clock fa-fw',
                location: 'sidebar',
                parent: 'finance.receivables.index',
            },
        },
    ],
}
